import './ui.css';

/**
 * Contenedor tipo "card" con encabezado opcional (título + acción) usado
 * para agrupar listas y bloques dentro de cada dashboard.
 *
 * @param {{ title?: string, action?: React.ReactNode, children: React.ReactNode }} props
 */
export default function SectionCard({ title, action, children }) {
  return (
    <section className="section-card">
      {(title || action) && (
        <div className="section-card__header">
          {title && <h2>{title}</h2>}
          {action}
        </div>
      )}
      <div className="section-card__body">{children}</div>
    </section>
  );
}
